"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContractCard = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ContractStats = require("./ContractStats");
require("./style.sass");
var _Tag = require("../Tag");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ContractCard = function ContractCard(_ref) {
  var contract = _ref.contract,
    date = _ref.date,
    countMembers = _ref.countMembers,
    accumulation = _ref.accumulation,
    _ref$accumulationText = _ref.accumulationText,
    accumulationText = _ref$accumulationText === void 0 ? 'накопление' : _ref$accumulationText,
    payments = _ref.payments,
    _ref$paymentsText = _ref.paymentsText,
    paymentsText = _ref$paymentsText === void 0 ? 'выплаты' : _ref$paymentsText,
    termination = _ref.termination,
    _ref$terminationText = _ref.terminationText,
    terminationText = _ref$terminationText === void 0 ? 'закрытые' : _ref$terminationText,
    status = _ref.status,
    dateTermination = _ref.dateTermination,
    className = _ref.className,
    isLoading = _ref.isLoading,
    contractInForceAsOfDate = _ref.contractInForceAsOfDate;
  var additionalDate = contractInForceAsOfDate ? " (\u0432 \u0440\u0435\u0434\u0430\u043A\u0446\u0438\u0438 \u043E\u0442 ".concat(contractInForceAsOfDate.split('-').reverse().join('.'), ")") : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('contract-card', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-card__status"
  }, !dateTermination ? status : /*#__PURE__*/_react.default.createElement(_Tag.Tag, null, "\u0417\u0430\u043A\u0440\u044B\u0442")), /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-card__number"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-title"
  }, "\u0414\u043E\u0433\u043E\u0432\u043E\u0440"), /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-description"
  }, "\u2116\xA0", isLoading ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      width: 100,
      display: 'block'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, null)) : contract, isLoading ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      width: 100,
      display: 'block'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0 \u043E\u0442\xA0", date), isLoading ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      width: 100,
      display: 'block'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, null)) : additionalDate)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('contract-card__members', {
      'contract-card__members--datermination': dateTermination
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-title"
  }, "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432\xA0", isLoading ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      width: 100
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, null)) : countMembers)), !dateTermination ? /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-card__groups"
  }, /*#__PURE__*/_react.default.createElement(_ContractStats.ContractStats, {
    title: accumulationText,
    description: accumulation,
    isLoading: !!isLoading
  }), /*#__PURE__*/_react.default.createElement(_ContractStats.ContractStats, {
    title: paymentsText,
    description: payments,
    isLoading: !!isLoading
  }), /*#__PURE__*/_react.default.createElement(_ContractStats.ContractStats, {
    title: terminationText,
    description: termination,
    isLoading: !!isLoading
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "contract-card__date-datermination"
  }, "\u0420\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442 ", dateTermination));
};
exports.ContractCard = ContractCard;
ContractCard.propTypes = {
  contract: _propTypes.default.string,
  date: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
  countMembers: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  accumulation: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  accumulationText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  payments: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  paymentsText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  termination: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  terminationText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  status: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  dateTermination: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  className: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  contractInForceAsOfDate: _propTypes.default.string
};